import React, {
  useRef, useState, useEffect,
} from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import './SelectInputStyles.scss';
import { useDispatch } from 'react-redux';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';
import Dropdown from '../../base/Dropdown/Dropdown';
import TextInput from '../TextInput/TextInput';
import renderMessage from '../renderMessage';
import { errorNotification } from '../../../modules/Notifications/notificationDecorator';
import { getIsRequired, getResponseError } from '../../../utils/utils';
import { metaDataFormatter, renderRegistryCarrierItemMin, renderRegistryOptionMin } from '../../../utils/formatters';
import { LOADING_DELAY } from '../../../configs';

export default function RegistryNumberSelectorById(props) {
  const {
    inputProps = null,
    className = '',
    fieldState = {
      error: '',
      touched: false,
    },
    variant = 'default',
    label,
    multiple = false,
    disabled = false,
    dtoObject,
    customValidator = [],
    defaultOptions = [],
    setOgrnValue,
    loadAction,
    formMeta,
    isNumberFormat = false,
    filter = {},
    customRenderOptions = () => null,
  } = props;
  const { error } = fieldState;
  const dispatch = useDispatch();
  const [defaults, setDefaults] = useState(defaultOptions);
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState('');
  const [timer, setTimer] = useState(null);
  const anchorElement = useRef(null);
  const inputRef = useRef(null);
  const isError = Boolean(error);
  const value = inputProps && (inputProps.value || typeof inputProps.value === 'boolean') ? inputProps.value : multiple ? [] : '';

  const optionFormatter = item => ({
    value: isNumberFormat ? item.number : item.id, name: item.number, applicant: item, number: item.number,
  });

  useEffect(() => {
    if (!value || !value.length) {
      loadOptions();
      return;
    }
    loadDefault(value);
  }, [JSON.stringify(value)]);

  const onChange = item => {
    if (!inputProps || !inputProps.onChange) return;
    setSearch('');
    const newValue = multiple ? [...value] : item.value === value ? '' : item.value;
    if (multiple) {
      const index = value.indexOf(item.value);
      if (index > -1) {
        const removed = newValue.splice(index, 1);
        const newDefs = [...defaults].filter(f => f.value !== removed[0]);
        setDefaults(newDefs);
      } else {
        newValue.push(item.value);
        setDefaults([...defaults, item]);
      }
    }
    inputProps.onChange({ target: { value: newValue, name: inputProps.name } });
    if (typeof setOgrnValue === 'function') { // todo костылище противный
      setOgrnValue(item?.applicant?.ogrn || '');
    }
  };

  const setInputFocus = () => {
    if (!inputRef || !inputRef.current) return;
    inputRef.current.focus();
  };

  const loadOptions = number => {
    dispatch(loadAction({ number, ...filter }))
      .then(data => {
        if (!data) { return; }
        setOptions((data || []).map(optionFormatter));
      })
      .catch(response => errorNotification('Загрузка данных', getResponseError(response)));
  };

  const loadDefault = v => {
    const data = {};
    data[`${isNumberFormat ? 'number' : 'id'}${Array.isArray(v) && multiple ? 's' : ''}`] = v;
    dispatch(loadAction(data))
      .then(data => {
        if (!data) { return; }
        setDefaults((data || []).map(optionFormatter));
      })
      .catch(response => errorNotification('Загрузка данных', getResponseError(response)));
  };

  const onChangeSearch = event => {
    const { value } = event.target;
    setSearch(value);
    if (!loadAction) return;
    if (timer) {
      clearTimeout(timer);
    }
    setTimer(setTimeout(() => { loadOptions(value); }, LOADING_DELAY));
  };

  const optionList = [...options, ...defaults.filter(item => !options.find(f => f.value === item.value))];
  const selectedItems = optionList.filter(item => (multiple ? value.includes(item.value) : value === item.value));
  const isRequired = getIsRequired(dtoObject, customValidator);

  return (
    <div className={classNames('form-control-wrapper', className)}>
      <Dropdown
        dropBottom
        usePortal
        disabled={disabled}
      >
        <Dropdown.Toggle className="select-toggle">
          <div
            ref={anchorElement}
            className={classNames('form-control-wrapper multiple-select', className, { material: variant === 'material' }, { default: variant !== 'material' })}
            onClick={setInputFocus}
          >
            <div className={classNames('input-block', { 'is-invalid': isError })}>
              {metaDataFormatter(formMeta, props?.name || '', renderMessage(label))}
              <div className="multiple-value-block">
                {selectedItems.map((item, index) => (
                  <div key={index} className="multiple-value registry-value">
                    {customRenderOptions(item, onChange) || renderRegistryOptionMin(item)}
                    {!customRenderOptions(item) ? (
                      <Icons
                        customIcon
                        className="multiple-value-delete"
                        width={18}
                        height={18}
                        icon="close"
                        onClick={event => {
                          onChange(item);
                          event.preventDefault();
                          event.stopPropagation();
                        }}
                      />
                    ) : null}
                  </div>
                ))}
                <TextInput inputProps={{ ref: inputRef, onChange: onChangeSearch, value: search }} />
              </div>
              <div htmlFor={props.id} className="form-input-label">
                {renderMessage(label)}{isRequired ? <span className="form-label-mark-required">*</span> : null}
              </div>
              <span className="input-after-block">
                <div className="select-arrow-wrapper">
                  <Icons customIcon className="select-arrow" width={12} height={8} icon="arrow-down" />
                </div>
              </span>
            </div>
            {isError ? <div className="invalid-feedback">{renderMessage(error)}</div> : null}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu
          key={optionList}
          disableClickToggle={multiple}
          rightPadding={32}
          className="select-options-wrapper"
          anchorElement={anchorElement}
          classNamePortal="portal-select-options multiple-select-option"
          useResizeContent={false}
        >
          {optionList && optionList.length ? (
            <div className="select-options-list">
              {optionList.map((item, key) => {
                const isSelected = !!value.includes(item.value);
                return (
                  <div
                    key={key}
                    className={classNames('select-option', { selected: isSelected })}
                    onClick={event => {
                      onChange(item);
                      event.preventDefault();
                      event.stopPropagation();
                    }}
                  >
                    {customRenderOptions(item) || renderRegistryOptionMin(item)}
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="select-options-empty-list">
              Список пуст
            </div>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
